import http from '../../Http-common';

const getAll = (keyword, roleId) => {
    return http.get(`/admin/account?draw=1&start=1&length=10&keyword=${keyword ? keyword : ''}&startDate=&endDate&roleId=${roleId ? roleId : ''}`);
}

const getById = (id) => {
    return http.get(`/admin/accountDetails?id=${id}`);
}

const getRoles = () => {
    return http.get('/admin/roles');
}

const create = (data) => {
    return http.post(`/admin/account`, data);
}

const deleted = (ids) => {
    return http.delete(`/admin/account?ids=${ids}`);
}

const AccountService = {
    getAll,
    getById,
    getRoles,
    create,
    deleted,
}

export default AccountService;